import React, { useState } from 'react';
import { Text } from 'atoms/Text/Text';
import { defaultTheme } from 'constants/theme/defaultTheme';
import { Button } from 'atoms/Button/Button';
import { Styles } from './styles';
import VTailDarkLogo from 'assets/svgs/vTailDarkLogo.svg';
import { Chevron } from 'atoms/Chevron';

type MobileFooterProps = {
  onClick: () => void;
};

export const MobileFooter = ({ onClick }: MobileFooterProps) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <>
      <Styles.Footer expand={expanded}>
        <Styles.Content expand={expanded}>
          {expanded && (
            <Styles.Icon>
              <VTailDarkLogo />
            </Styles.Icon>
          )}
          {expanded ? (
            <Styles.ExpandedText>
              <Text.button2 color={defaultTheme.colors.white}>
                Instant access to all of the product information you need
              </Text.button2>
            </Styles.ExpandedText>
          ) : (
            <Text.button2 color={defaultTheme.colors.white}>Get the full experience</Text.button2>
          )}

          {expanded ? (
            <Button text="Sign up now" onClick={onClick} />
          ) : (
            <Styles.CollapsedButton expand={expanded}>
              <Button block smallPadding onClick={onClick} text="Learn more" />
            </Styles.CollapsedButton>
          )}
        </Styles.Content>
        <Styles.ChevronButton
          onClick={() => setExpanded(expanded => !expanded)}
          aria-label="toggle"
        >
          <Chevron
            type={expanded ? 'down' : 'up'}
            color={defaultTheme.colors.white}
            opacity={1}
            scale={1.1}
          />
        </Styles.ChevronButton>
      </Styles.Footer>
    </>
  );
};
